<template>
  <div class="card skeleton-card">
    <div class="card-header skeleton-header">
      <div class="skeleton-line skeleton-title" />
    </div>
    <div class="card-content">
      <div class="skeleton-line skeleton-text-line" style="width: 72%" />
      <div class="skeleton-line skeleton-text-line" style="width: 58%" />
      <div class="skeleton-line skeleton-text-line" style="width: 65%" />
      <div class="skeleton-line skeleton-text-line" style="width: 43%" />
      <div class="skeleton-line skeleton-text-line" style="width: 69%" />
      <div class="skeleton-line skeleton-text-line" style="width: 52%" />
      <div class="skeleton-line skeleton-text-line" style="width: 61%" />
      <div class="skeleton-line skeleton-text-line" style="width: 76%" />
      <div class="skeleton-line skeleton-text-line" style="width: 48%" />
      <div class="skeleton-line skeleton-text-line" style="width: 64%" />
      <div class="skeleton-line skeleton-text-line" style="width: 38%" />
      <div class="skeleton-line skeleton-text-line" style="width: 55%" />
    </div>
  </div>
</template>

<style scoped>
@keyframes shimmer {
  0% {
    background-position: -400px 0;
  }
  100% {
    background-position: 400px 0;
  }
}

.skeleton-card .card-header {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.skeleton-header {
  padding: 0.75rem 1rem;
  align-items: center;
}

.skeleton-line {
  border-radius: 4px;
  background: linear-gradient(90deg, #ebebeb 25%, #f5f5f5 50%, #ebebeb 75%);
  background-size: 800px 100%;
  animation: shimmer 1.4s infinite linear;
}

.skeleton-title {
  height: 1rem;
  width: 10rem;
  margin: 0.25rem 0;
}

.skeleton-text-line {
  height: 0.8rem;
  margin-bottom: 0.75rem;
}

.skeleton-text-line:last-child {
  margin-bottom: 0;
}
</style>
